export interface IFile {
    hash: string;
    name: string;
    type: string;
    parentHash: string;
    owner: any;
    uploader: any;
    attributes: string[];
    created: number;
    updated: number;
    extension: string;
    size: number;
    metaData: string;
    version: number;
    thumbnail: "WAITING_FOR_THUMBNAIL" | string;
    uploadTime?: number;
    abort?: () => void;
    progress?: number;
    folderHash?: string;
    uploadState?: "SUCCESS" | "ERROR" | "START";
    shouldDelete?: boolean;
    cancelUpload?: boolean;
    success?: boolean;
    error?: boolean;
}

export interface IPodspaceResult<T> {
    path: string;
    reference: string;
    result: T;
    status: number;
    timestamp: string;
}

export interface IClasorServerResult<T> {
    [x: string]: any;
    data?: T;
}

export enum ERequest {
    GET = "get",
    POST = "post",
    PUT = "put",
    PATCH = "patch",
    DELETE = "delete",
    HEAD = "head",
}

export enum ERoles {
    admin = "admin",
    editor = "editor",
    owner = "owner",
    viewer = "viewer",
    writer = "writer",
    default = "default",
}
